import { ErrorResponse, FgStatusEnum, JobCompletedEnum, OperationTypeEnum } from '@gtpl/shared-models/common-models';
import { UnitTypeEnum } from '@gtpl/shared-models/masters';
import { AssignForCookingResponse, CookingDto, CookingInventoryDto, CookingInventoryResponse, GetCookingInfoResponse } from '@gtpl/shared-models/production-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import appSettings from 'apps/services/config';
import { getManager, Raw } from 'typeorm';
import { VariantOperationsService } from '../../variant-operations/variant-operations.service';
import { WorkStations } from '../../workstations/workstations.entity';
import { OperationSequenceRequest } from '../dto/operation-sequence.request';
import { ProductionInventoryData } from '../dto/production-inventory.dto';
import { ProductionInventory } from '../entities/production-inventory.entity';
import { ProductionLog } from '../entities/production-log.entity';
import { ProductionLogService } from '../production-log.service';
import { ProductionInventoryRepository } from '../repositories/production-inventory.repository';
import { ProductionLogRepository } from '../repositories/production-log.repository';


const salesSoTable = appSettings.sales_db + '.sale_order';
const salesSoItemTable = appSettings.sales_db + '.sale_order_items';
const salesInvTable = appSettings.sales_db + '.so_invoice_details';
const productionLogTable = appSettings.production_db + '.production_log';
const productionInvTable = appSettings.production_db + '.production_inventory';
const workStationTable = appSettings.production_db + '.workstations';
@Injectable()
export class CookingService {
    constructor(@InjectRepository(ProductionInventoryRepository)
    private inventoryRepository: ProductionInventoryRepository,
        @InjectRepository(ProductionLogRepository)
        private logRepository: ProductionLogRepository,
        private variantOperationService: VariantOperationsService) { }

    async getCookingInprogressLogs(plantId: number): Promise<GetCookingInfoResponse> {
        try {
            const response: CookingDto[] = await this.logRepository.getCookingInprogressLogs(plantId);
            if (response && response.length) {
                return new GetCookingInfoResponse(true, 1111, 'Cooking Info Retrieved Successfully', response);
            } else {
                return new GetCookingInfoResponse(false, 1111, 'No Inprogress Cooking Info');
            }
        } catch (error) {
            return error;
        }
    }

    async getCookingInventory(plantId: number): Promise<CookingInventoryResponse> {
        try {
            const response: CookingInventoryDto[] = await this.inventoryRepository.getCookingInventory(plantId);
            if (response && response.length) {
                return new CookingInventoryResponse(true, 1111, 'Cooking Inventory Retrieved Successfully', response);
            } else {
                return new CookingInventoryResponse(false, 1111, 'No Cooking Inventory Found', response);
            }
        } catch (error) {
            return error;
        }
    }

    async getReadyForCookingInventory(plantId: number): Promise<CookingInventoryResponse> {
        try {
            // const response: CookingInventoryDto[] = await this.inventoryRepository.getReadyForCookingInventory(plantId);
            const manager = getManager();
      const uquery='select plant_type from '+appSettings.masters_db+'.unitcodes where unit_code_id='+plantId;
      const result =await manager.query(uquery);
      let query = `SELECT prod_inv_id as productionInventoryId, CONCAT(COALESCE(gi.lot_number, ''), '  ',COALESCE(gi.remarks, '') ) as lotNumber, inv.sale_order_id as saleOrderId, so.sale_order_no as soNumber, sc.variant_code as variantCode, issued_quantity as inputQuantity, inv.plant_id plantId, inv.created_user createdUser, inv.sale_order_item_id as saleOrderItemId, operation as operationType, next_operation as nextOperation, inv.status,si.po_number as poNumber, physical_quantity as physicalQuantity FROM ` + productionInvTable + ` inv 
            LEFT JOIN `+ salesSoTable + ` so ON so.sale_order_id=inv.sale_order_id
            LEFT JOIN `+ salesSoItemTable + ` soi ON soi.sale_order_item_id=inv.sale_order_item_id
            LEFT JOIN `+ appSettings.masters_db + `.sku_codes sc ON sc.sku_code_id=soi.varient_id
            LEFT JOIN `+ salesInvTable + ` si ON si.sale_order_id=inv.sale_order_id
            left join `+appSettings.rm_procure_db+`.grn_items gi ON gi.lot_number = inv.lot_number
            where  inv.next_operation='${OperationTypeEnum.COOKING}'`
            if(result[0].plant_type==UnitTypeEnum.SUB_PLANT){
              query += "AND inv.sub_plant_id="+plantId;
            }else{
              query += "AND inv.plant_id="+plantId+' and inv.sub_plant_id = 0';
            }

      const response: CookingInventoryDto[] = await manager.query(query);
            console.log(response)
            if (response && response.length) {
                return new CookingInventoryResponse(true, 1111, 'Cooking Inventory Retrieved Successfully', response);
            } else {
                return new CookingInventoryResponse(false, 1111, 'No Data For Ready For Cooking', response);
            }
        } catch (error) {

            return error;
        }
    }



    async assignToCooking(cooking: ProductionInventoryData): Promise<AssignForCookingResponse> {
        const manager = new GenericTransactionManager();
        let nextOperation: OperationTypeEnum =OperationTypeEnum.NO_OPERATION;
        const opSequence = await this.variantOperationService.getOperationSequence(new OperationSequenceRequest(cooking.plantId, cooking.operation, cooking.saleOrderItemId));

        if (opSequence.status) {
            nextOperation = opSequence.data.nextOperation
            if (!(nextOperation == OperationTypeEnum.NO_OPERATION)) {
                nextOperation = opSequence.data.nextOperation;
            } else {
                nextOperation = OperationTypeEnum.NO_OPERATION
            }
        } else {
            throw new ErrorResponse(9999, 'No operation sequence found for saleorder');
        }

        try {

            await manager.startTransaction();
            let columnName = 'plantId' ;//No subplant operation for cooking
            const updateInv = await manager.getCustomRepository(ProductionInventoryRepository).update(
                { productionInventoryId:cooking.productionInventoryId, subLotNumber: Raw((alias) => `sub_lot_number = '${cooking.subLotNumber}'`) },
                { status: FgStatusEnum.IN_PROGRESS }
            );console.log(updateInv,'updateInv???')
            if (updateInv.affected) {

                const productionInventoryData = await this.inventoryRepository.findOne({ where: { lotNumber: cooking.lotNumber, subLotNumber: cooking.subLotNumber, saleOrderId: cooking.saleOrderId, saleOrderItemId: cooking.saleOrderItemId, operation: OperationTypeEnum.COOKING, plantId: cooking.plantId } });
                let prodInvResponse;
                // cooking.subLotNumber = cooking.subLotNumber
                cooking.operation = OperationTypeEnum.COOKING
                cooking.wipQuantity = cooking.physicalQuantity;
                cooking.ipBoxes = cooking.boxes;
                console.log(productionInventoryData,'productionInventoryData???')
                if (productionInventoryData) {
                    prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryQuantity(cooking,columnName);
                } else {
                    const prodInv = new ProductionInventory();
                    prodInv.lotNumber = cooking.lotNumber;
                    prodInv.createdUser = cooking.createdUser;
                    prodInv.subLotNumber = cooking.subLotNumber;
                    prodInv.saleOrderId = cooking.saleOrderId;
                    prodInv.saleOrderItemId = cooking.saleOrderItemId;
                    prodInv.operation = OperationTypeEnum.COOKING;
                    prodInv.nextOperation = nextOperation;
                    prodInv.physicalQuantity = cooking.physicalQuantity;
                    prodInv.inputGrade = cooking.inputGrade;
                    prodInv.boxes = cooking.boxes;
                    prodInv.plantId = cooking.plantId;
                    if (cooking.subPlantId) {
                        prodInv.subPlantId = cooking.subPlantId;
                    }
                    prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);


                }
                // const updateLogStatus = await manager.getCustomRepository(ProductionLogRepository).update(
                //     { subLotNumber: Raw((alias) => `sub_lot_number = '${cooking.subLotNumber}'`),operationType:OperationTypeEnum.COOKING },
                //     { assignCooking: true, jobStatus: JobCompletedEnum.YES }
                // );console.log(updateLogStatus,'updateLogStatus*')
                if (prodInvResponse) {
                    const prodLog = new ProductionLog();

                    // job number generation 
                    const today = new Date();
                    const CurrentYear = today.getFullYear();
                    const CurrentMonth = today.getMonth();
                    let fromDate = 0;
                    let toDate = 0;
                    let totalRecords = await (await this.logRepository.find({ where: { operationType: OperationTypeEnum.COOKING } })).length;
                    if (CurrentMonth < 4) {
                        fromDate = (CurrentYear-1);
                        toDate = (CurrentYear);
                    } else {
                        fromDate = (CurrentYear);
                        toDate = (CurrentYear + 1);
                    }

                    totalRecords = totalRecords + 1;

                    let refNo = totalRecords + "";
                    while (refNo.length < 4) refNo = "0" + refNo;

                    const freezingJobNo = "Cooking/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

                    prodLog.jobNumber = freezingJobNo;
                    prodLog.lotNumber = cooking.lotNumber;
                    prodLog.subLotNumber = cooking.subLotNumber;
                    prodLog.saleOrderId = cooking.saleOrderId;
                    prodLog.inputQuantity = cooking.physicalQuantity;
                    prodLog.assignCooking = true;
                    prodLog.jobStatus = JobCompletedEnum.NO;
                    prodLog.shift = cooking.shift;
                    prodLog.assignedTime = cooking.assignedTime;
                    prodLog.plantId = cooking.plantId;
                    prodLog.createdUser = cooking.createdUser;
                    prodLog.workstation = new WorkStations();
                    prodLog.workstation.workstationId = cooking.workstation;
                    prodLog.saleOrderItemId = cooking.saleOrderItemId;
                    prodLog.operationType = OperationTypeEnum.COOKING;
                    prodLog.inputGrade = cooking.inputGrade;
                    prodLog.inputBoxes = cooking.boxes;
                    prodLog.prodInvId = prodInvResponse.productionInventoryId
                    prodLog.assignedUser = cooking.createdUser;
                    prodLog.assignCooking = true;
                    const saveProdLog = await manager.getCustomRepository(ProductionLogRepository).save(prodLog);
                    
                    const updatePrevOPQty = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryIssuedQuantity(cooking.lotNumber, cooking.subLotNumber, cooking.saleOrderId, cooking.saleOrderItemId, cooking.productionInventoryId, cooking.plantId, cooking.physicalQuantity);
                    
                    // console.log(prodInvResponse,'prodInvResponse*')
                    console.log(updatePrevOPQty,'updatePrevOPQty*')
                    console.log(saveProdLog)
                    console.log(prodInvResponse)
                    console.log(updatePrevOPQty)
                    console.log(cooking);
                    if (saveProdLog && prodInvResponse && updatePrevOPQty) {
                        manager.completeTransaction();
                        return new AssignForCookingResponse(true, 5555, 'Assigned to Cooking', true)
                    } else {
                        manager.releaseTransaction();
                        return new AssignForCookingResponse(false, 9999, 'some thing went wrong', false)
                    }
                } else {
                    manager.releaseTransaction();
                    throw new ErrorResponse(9999, 'Failed to create');
                }
            }
            else {
                await manager.releaseTransaction();
                throw new ErrorResponse(9999, 'Failed to update');
            }
        } catch (error) {
            await manager.releaseTransaction();
            throw error;
        }
    }

    async jobCompletedStatus(cooking: CookingDto): Promise<AssignForCookingResponse> {
        // const manager = new GenericTransactionManager();
        const updateStatus = await this.logRepository.update(
            { lotNumber: Raw((alias) => `lot_number = '${cooking.lotNumber}'`) },
            { jobStatus: JobCompletedEnum.YES }
        );
        if (updateStatus) {
            // const prodLog =  new ProductionLog();
            // prodLog.jobNumber = 'freezing001';
            // prodLog.lotNumber = cooking.lotNumber;
            // prodLog.subLotNumber = cooking.lotNumber;
            // prodLog.saleOrderId = cooking.saleOrderId;
            // prodLog.inputQuantity = cooking.physicalQuantity;
            // prodLog.assignFreezing = cooking.assignFreezing;
            // prodLog.jobStatus = cooking.jobStatus;
            // prodLog.shift = cooking.shift;
            // prodLog.assignedTime = cooking.assignedTime;
            // prodLog.plantId = cooking.plantId;
            // prodLog.createdUser = cooking.createdUser;
            // prodLog.workstation = new WorkStations();
            // prodLog.workstation.workstationId = cooking.workstation;
            // prodLog.saleOrderItemId = cooking.saleOrderItemId;
            // prodLog.operationType = OperationTypeEnum.COOKING;
            // prodLog.assignedUser = cooking.createdUser;
            // prodLog.createdUser = cooking.createdUser;
            // prodLog.inputBoxes = cooking.boxes;
            // prodLog.shift = cooking.shift;
            // prodLog.inputGrade = cooking.inputGrade;

            // const saveProdLog = await this.repository.save(prodLog);

            return new AssignForCookingResponse(true, 1111, 'Updated to completed');

        } else {
            throw new ErrorResponse(9999, 'Failed to update');
        }
    }



}
